import { Component, ElementRef, Input, OnInit, ViewChild } from '@angular/core';
import { FormBuilder, FormGroup, FormGroupDirective, Validators } from '@angular/forms';
import { Constants } from '../../../../core/services/constants.service';
import { HttpService } from '../../../../core';
import { environment } from '../../../../../environments/environment';
import { ToastrService } from 'ngx-toastr';
import { MatDialog } from '@angular/material/dialog';
import { ArModelComponent } from './ar-model/ar-model.component';
import { forkJoin } from "rxjs";


@Component({
  selector: 'app-floor-plan',
  templateUrl: './floor-plan.component.html',
  styleUrls: ['./floor-plan.component.scss']
})

export class FloorPlanComponent implements OnInit {

  notesArray = [];

  reactiveForm: FormGroup;
  @Input() project: any;
  @ViewChild('addtionalImage') private additional: ElementRef;
  mode: any;
  images = [];
  additionnalImage = [];
  isFileNameValid: boolean;
  isAddtionalFileNameValid: boolean;

  isNewNotesValid = { id: null };
  dataSource: any;
  page: number;
  pageSize: number;

  selectedFloorPlans = [];
  SERVER_URL = environment.SERVER_URL;

  newFloorPlanForm: any;
  constants = Constants;

  isSubmitted: boolean;

  isUploading: boolean;

  isAdditionalImageUploading: boolean;

  // User 点选的户型ID
  selectedFloorPlanId: number;
  // AR模型的表单控制
  newARModelForm: FormGroup;
  // 新添户型后 获得的户型id
  newFloorPlanId: number;


  @ViewChild('formDirective') private formDirective: FormGroupDirective;


  constructor(private httpService: HttpService,
    // private projectService: ProjectService,
    private fb: FormBuilder,
    private toastrService: ToastrService,
    private dialog: MatDialog
  ) {
    this.reactiveForm = fb.group({
      floorPlanId: [''],
      file: []
    });
    this.newFloorPlanForm = fb.group({
      notes: ['', [Validators.maxLength(200), Validators.required]]
    });
  }

  ngOnInit(): void {
    this.mode = 'manage';
    this.dataSource = this.project.floorPlans;
    // this.project.floorPlans.map(floorPlan => {
    //   this.notesArray.push({
    //
    //   })
    // })
    console.log(this.project);

  }

  changeMode(event) {
    this.mode = event.value;
  }

  isFileValid(file) {
    return file.size <= Constants.UPLOAD_FLOOR_PLAN_IMAGE_SIZE && file.name.length < 255;
  }

  onFileChange(event) {
    if (event.target.files && event.target.files[0]) {
      for (let i = 0; i < 1; i++) {
        if (this.isFileValid(event.target.files[i])) {
          this.selectedFloorPlans.push(event.target.files[i]);
          this.isFileNameValid = true;
        } else {

          this.isFileNameValid = false;
        }
      }
      console.log(this.selectedFloorPlans);
    }
  }

  additionalImageSelected(event) {
    if (event.target.files && event.target.files[0]) {
      for (let i = 0; i < 1; i++) {
        if (this.isFileValid(event.target.files[i])) {
          this.additionnalImage.push(event.target.files[i]);
          this.isAddtionalFileNameValid = true;

        } else {
          this.isAddtionalFileNameValid = false;

          console.log(this.additional);
        }
      }
    }
  }

  uploadFloorPlans() {
    this.isSubmitted = true;
    this.isUploading = true;
    const fd = new FormData();
    fd.append('projectId', this.project.id);
    // fd.append('notes')
    //
    this.selectedFloorPlans.forEach((file) => {
      fd.append('images', file);
    });

    if (this.newFloorPlanForm.get('notes').value) {
      fd.append('notes', this.newFloorPlanForm.get('notes').value);
    }

    this.httpService.uploadFloorPlans(fd).subscribe((res: any) => {
      console.log(res);
      if (res.code === 1) {
        this.selectedFloorPlans = [];
        this.mode = 'upload';
        this.newFloorPlanId = res.data.id;
        if (this.project.floorPlans) {
          this.project.floorPlans.unshift(res.data);
        } else {
          this.project.floorPlans = [res.data];
        }
        this.isUploading = false;

        this.toastrService.success('Floor plan uploading successful');
      } else {
        this.isUploading = false;
        this.toastrService.error('Floor plan uploading failed');
      }
    });
  }

  addMoreImageToFloorPlan() {
    if (this.reactiveForm.invalid) {
      return;
    }
    this.isAdditionalImageUploading = true;
    const fd = new FormData();
    this.additionnalImage.forEach((file) => {
      fd.append('image', file);
    });

    const selectedFloorPlan = this.reactiveForm.get('floorPlanId').value;

    this.httpService.addImageToFloorPlan(fd, selectedFloorPlan).subscribe((res: any) => {
      console.log(res);
      this.additionnalImage = [];
      this.project.floorPlans.forEach((floorPlan) => {
        if (floorPlan.id === selectedFloorPlan) {
          floorPlan.images = res.data.images;
        }
      });

      // this.additionnalImage = [];
      // this.reactiveForm.reset();
      console.log(this.additional);
      this.additional.nativeElement.value = '';
      this.formDirective.resetForm();
      this.isAdditionalImageUploading = false;


    });


  }


  deleteFloorPlan(floorPlanId) {
    this.httpService.deleteFloorPlans(floorPlanId).subscribe((res: any) => {
      console.log(res);
      if (res.code === 1) {
        this.project.floorPlans = this.project.floorPlans.filter((f) => {
          return f.id !== floorPlanId;
        });
        // this.project.floorPlans.forEach((floorPlan) => {
        //   this.floorPlanIds.push(floorPlan.id);
        // });
        this.toastrService.success('Floor plan ' + floorPlanId + ' has been deleted.');
      } else if (res.code === 0) {
        this.toastrService.error('Failed to delete this floor plan');
      }
    });
  }

  deleteImageFromFloorPlan(floorPlanId, imageId) {
    console.log(floorPlanId, imageId);
    this.httpService.deleteImageFromFloorPlan(floorPlanId, imageId).subscribe((res: any) => {
      console.log(res);
      if (res.code === 1) {
        this.project.floorPlans.forEach((floorPlan) => {
          if (floorPlan.id === res.data.id) {
            floorPlan.images = res.data.images;
          }
        });
        this.toastrService.success('One image has been deleted from floor plan ' + floorPlanId);
      } else {
        this.toastrService.error('Failed to delete this image.');
      }
    });
  }

  encodeURI(url) {
    return encodeURI(url);
  }


  editNotes(id, notes) {
    console.log(id, notes);
    if (notes.length === 0 || notes.length > 250) {
      this.isNewNotesValid.id = id;
      return;
    }

    const fd = new FormData();
    fd.append('projectId', this.project.id);
    fd.append('notes', notes);
    this.httpService.editFloorPlanNotes(fd, id).subscribe((res: any) => {
      console.log(res);
      if (res.code === 1) {
        this.toastrService.success('Floor plan notes has been updated.');
      } else {
        this.toastrService.error('Failed to update floor plan notes.');
      }
    });
  }

  // 添加AR 模型的弹窗
  openArModelDialog(floorPlanId) {
    this.selectedFloorPlanId = floorPlanId;
    const dialog = this.dialog.open(ArModelComponent, {
      width: '80%',
      data: {
        floorPlanId: this.selectedFloorPlanId
      }
    });
    dialog.afterClosed().subscribe((result: any) => {
      console.log(result);
    });
  }

  deleteAr(floorPlanId) {
    forkJoin([this.httpService.deleteAndroidAr(floorPlanId), this.httpService.deleteIosAr(floorPlanId)]).subscribe((res: any) => {
      console.log(res);
      if (res[0].code === 1 && res[1].code === 1) {
        this.toastrService.success('Delete ios and android AR successfully');
      } else {
        this.toastrService.error('Delete AR failed');
      }
    });
  }

}
